module.exports = __webpack_public_path__ + "static/media/jabam2.a209566e.png";